import { ChatWidgetProvider } from '@/context/ChatWidgetContext';

import ChatBubble from './ChatBubble';
import ChatWindow from './ChatWindow';

interface ChatWidgetProps {
  documentId?: string;
}

const ChatWidget: React.FC<ChatWidgetProps> = ({ documentId }) => (
  <ChatWidgetProvider documentId={documentId}>
    <ChatBubble />
    <ChatWindow />
  </ChatWidgetProvider>
);

export default ChatWidget;
